import { Routes } from '@angular/router'
import { LayoutSessionComponent } from './modules/session/components/layout-session/layout-session.component'
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component'
import { authGuard } from '@shared/guards/auth.guard'
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component'
import { sessionGuard } from '@session/guard/session.guard'
import { levelsGuard } from './modules/shared/guards/levels.guard'

export const routes: Routes = [
  {
    path: 'session',
    canActivate: [sessionGuard],
    component: LayoutSessionComponent,
    loadChildren: () => import('@session/session.routing').then(m => m.routes),
  },
  {
    path: 'solventa',
    canActivate: [authGuard],
    component: AppLayoutComponent,
    children: [
      {
        path: 'invitation',
        loadChildren: () => import('@invitation/invitation.routing').then(m => m.routes),
      },
      {
        path: 'phone',
        loadChildren: () => import('@phone-confirmation/phone-confirmation.routing').then(m => m.routes),
      },
      {
        path: 'home',
        loadChildren: () => import('@home/home.routing').then(m => m.routes),
      },
      {
        path: 'terms',
        loadComponent: () => import('@terms/terms.component'),
      },
      {
        path: 'questionnaire',
        loadComponent: () => import('@questionnaire/pages/questionnaire/questionnaire.component'),
      },
      {
        path: 'payment/:idBank',
        loadComponent: () => import('@payment/pages/payment/payment.component'),
      },
      {
        path: 'payment-info',
        loadComponent: () => import('@payment/pages/payment-info/payment-info.component'),
      },
      {
        path: 'document',
        loadComponent: () => import('@document/pages/document/document.component'),
      },
      {
        /* LEVEL 0 ROUTE */
        path: 'request-loan',
        canActivate: [levelsGuard],
        loadComponent: () => import('@request-loan/pages/request-loan-layout/request-loan-layout.component'),
      },
      {
        /* LEVEL 1 ROUTE */
        path: 'request-loan-module',
        loadComponent: () => import('@request-loan-module/pages/layout/layout.component'),
      },

      {
        /* LEVEL 1 ROUTE */
        path: 'kyc-request',
        loadComponent: () => import('@request-loan-module/pages/kyc/kyc.component'),
      },

      {
        path: 'notification',
        loadComponent: () => import('@notification/pages/notification/notification.component'),
      },

      /* CAMERA PREVIEW ROUTE */
      {
        path: 'camera-preview',
        loadComponent: () => import('@shared/pages/camera-preview/camera-preview.component'),
      },
      /*
        TAKING PICTURES FOR VEHICLES PAGE
        WIP
      */
      /* {
        path: 'vehicle-camera',
        loadComponent: () => import('@shared/pages/vehicle-camera/vehicle-camera.component'),
      }, */
    ],
  },
  {
    path: '',
    redirectTo: 'session/login',
    pathMatch: 'full',
  },
  {
    path: 'notfound',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'notfound',
  },
]
